import {
  InstalmentFreePeriodMonthsDurationRange,
  OTHER_REASON_FOR_IFP_MAX_LENGTH,
  PrimaryReasonForIfp,
} from '@shared/sec-loans'
import { YesNo } from '@ui-common/types'
import { validateDate, validateTextArea } from '@ui-common/utils'
import { FieldName } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, only, Suite, test } from 'vest'

import {
  durationInMonthsOptionsOneToSix,
  durationInMonthsOptionsSevenToTwelve,
  IfpBasicInfoFormData as FormData,
} from './types'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
): Suite<string, string, (data: FormData, changedFields?: FieldName<FormData>[]) => void> => {
  return create((data, changedFields) => {
    only(changedFields)

    test('durationInMonthsRange', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.durationInMonthsRange).inside(Object.values(InstalmentFreePeriodMonthsDurationRange))
    })

    omitWhen(data.durationInMonthsRange !== InstalmentFreePeriodMonthsDurationRange.OneToSix, () => {
      test('durationInMonths', formatMessage({ id: 'validate-required-field-missing' }), () => {
        enforce(data.durationInMonths).inside(durationInMonthsOptionsOneToSix)
      })
    })

    omitWhen(data.durationInMonthsRange !== InstalmentFreePeriodMonthsDurationRange.SevenToTwelve, () => {
      test('durationInMonths', formatMessage({ id: 'validate-required-field-missing' }), () => {
        enforce(data.durationInMonths).inside(durationInMonthsOptionsSevenToTwelve)
      })
    })

    test('startsImmediately', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.startsImmediately).inside(Object.values(YesNo))
    })

    omitWhen(data.startsImmediately !== YesNo.No, () => {
      const ONE_YEARS_MILLISECONDS = 365 * 24 * 60 * 60 * 1000
      validateDate({
        fieldName: 'startDate',
        formatMessage,
        isRequired: true,
        valueToValidate: data.startDate,
        minMax: { minimumValue: new Date(), maximumValue: new Date(new Date().getTime() + ONE_YEARS_MILLISECONDS) },
      })
    })

    test('primaryReason', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.primaryReason).inside(Object.values(PrimaryReasonForIfp))
    })

    validateTextArea(
      formatMessage,
      'primaryReasonOther',
      data.primaryReasonOther,
      OTHER_REASON_FOR_IFP_MAX_LENGTH,
      true,
    )

    test('hasFinancialDifficulties', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.hasFinancialDifficulties).inside(Object.values(YesNo))
    })
  })
}
